import request from '@/router/axios'
import env from '@/config/env'

/**
 * 开票列表
 */
// export const getOrder = (orderNo) => {
//     return request({
//       url: env.ferryUrl + '/invoice-issuer/list',
//       method: 'GET',
//       params: {
//         orderNo: orderNo
//       }
//     })
//   }

/**
 * 开票列表
 * @param params
 */
export const getPage = (params) => {
  return request({
    url: env.ferryUrl + '/invoice-issuer/page',
    method: 'POST',
    data: params
  })
}

/**
 * 开票编辑
 * @param params
 */
export const save = (params) => {
  return request({
    url: env.ferryUrl + '/invoice-issuer/save',
    method: 'POST',
    data: params
  })
}

/**
 * 企业名称列表
 * @param params
 */
export const getEnterpriseName = (params) => {
  return request({
    url: env.ferryUrl + '/invoice-issuer/list',
    method: 'POST',
    data: params
  })
}

/**
 * 开票管理删除
 * @param params
 */
export const invoiceDelete = (id) => {
  return request({
    url: env.ferryUrl + `/invoice-issuer/delete/${id}`,
    method: 'DELETE'
  })
}
